<template>
  <v-layout>
    <v-flex>
      <template>
        <v-card>
          <div>
            <v-container fluid class="pa-0">
              <v-layout column wrap align-center>
                <v-flex xs12>
                  <div class="text-xs-center">
                    <div>
                      <v-btn @click="addEmptyUrl()" color="primary" fab small dark>
                        <v-icon>add</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
            <v-form>
              <v-text-field
                v-for="(url, i) in urls"
                :key="i"
                :value="url"
                @input="updateUrl($event, i)"
                :placeholder="'url'"
              >
                <v-icon @click="deleteUrl(i)" slot="append">delete</v-icon>
              </v-text-field>
            </v-form>
            <div style="text-align: left;" v-if="log.length > 0">Log:</div>
            <pre style="max-height: 300px; overflow: scroll; text-align: left;" v-if="log.length > 0">{{ log }}</pre>
            <v-container fluid class="pa-0">
              <v-layout column wrap align-center>
                <v-flex xs12>
                  <div class="text-xs-center">
                    <div>
                      <v-btn @click="cleanCache()" color="primary" small dark :loading="loading">
                        Clean cache
                      </v-btn>
                    </div>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </div>
        </v-card>
      </template>
    </v-flex>
  </v-layout>
</template>

<script>
import $http from '@/api';

export default {
  name: 'nx-backstage-url-cache',
  data() {
    return {
      urls: [''],
      log: [],
      loading: false,
    };
  },
  computed: {
    validatedUrls() {
      return this.urls.filter(url => url !== '');
    },
  },
  methods: {
    addEmptyUrl() {
      this.urls.push('');
    },
    updateUrl(event, index) {
      this.urls[index] = event;
    },
    deleteUrl(index) {
      this.urls.splice(index, 1);
    },
    async cleanCache() {
      this.loading = true;
      try {
        this.log = await $http.post('/api/backstage/cache/invalidate-urls', this.validatedUrls);
      } catch (e) {
        const json = JSON.stringify(e.response.data, null, 2);

        this.log = [
          `Error! Status ${e.response.status} - ${e.response.statusText}`,
          json.split('\n'),
        ];
      } finally {
        this.loading = false;
      }
    },
  },
};

</script>
<style>
  form {
    padding-right: 8px;
    padding-left: 8px;
  }
</style>
